import { removeTenderFilterRoutine } from '@modules/tender-platform/children/tender-search/actions';
import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import initialState from '@modules/tender-platform/children/tender-search/store';

export const removeTenderFilterReducer = createReducer(initialState, {
  [removeTenderFilterRoutine.SUCCESS]: (state, action: PayloadAction<number>) => {
    state.filters = state.filters.filter((filter) => filter.key !== action.payload);
  }
});
